import styled from 'styled-components';

// TODO: TFR-44 move to container group
const Container = styled.div`
  background: ${({ theme }) => theme.colors.greenDark};
  display: flex;
  height: 100vh;
  width: 100vw;
`;

export default Container;

// TODO: TFR-29 add stories to component
